import { Component, input } from '@angular/core';
import { RidDialogLineIndicator } from '../rid-dialog-line-indicator/rid-dialog-line-indicator';

@Component({
  selector: 'rid-dialog-line',
  imports: [RidDialogLineIndicator],
  templateUrl: './rid-dialog-line.html',
  host: {
    'animate.enter': 'anim-fade-from-bottom',
    '[style.animation-delay.ms]': '100 * index()',
  },
})
export class RidDialogLine {
  line = input.required<{ speaker: 'LEFT' | 'RIGHT'; content: string }>();
  index = input.required<number>();
}
